import axios from "./api";
const headers =
  typeof window !== "undefined"
    ? {
        Authorization: `${localStorage.getItem("token")}`,
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      }
    : {};

export const getCategories = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}categoryListHome`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getRegions = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}regionsHome`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getManufacturers = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}manufacturers`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getTopManufacturers = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}topManufacturer`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getCount = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/dashboardCount`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saverfqrequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/rfqRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const loggedInInfo = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.GATSBY_API_URL}me`,
      headers,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const logOut = async (callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}logout`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const checkToken = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers:
        typeof window !== "undefined"
          ? {
              Authorization: `${
                localStorage.getItem("mimictoken") ||
                localStorage.getItem("token")
              }`,
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}user/checkSession`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const markAsRead = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/markAsRead`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getConversation = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/conversation/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const askQuestion = async (data) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion`,
    });
    return response;
  } catch (e) {
    return e;
  }
};
